import type { PackagingInformationEntry } from "~/domains/product/types/ProductData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { getPriceInfo } from "~/domains/product/utils/productDescriptorUtils";

export function canAddProductToCart(
  product: ProductDescriptor,
  packaging: PackagingInformationEntry | undefined | null,
) {
  if (!packaging || !product.isLoaded) {
    return false;
  }

  const priceInfo = getPriceInfo({ product, packCode: packaging.packCode });
  return (priceInfo?.hasPrice ?? false) && (product.availability?.hasPackaging ?? false);
}
